import React, { useState, useEffect, useRef } from "react";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  formatDateForAPI,
  buildRangeState,
  buildEmptyRangeState,
  dateRangePickerProps,
  hasVisibleDateSelection,
} from "../../utils/dashboardDateRange";

/**
 * Calendar + Apply/Reset actions with no pre-selected range until the user picks dates.
 * Pass isOpen when used inside a dropdown so the picker resets each time it opens.
 */
const DateRangeFilterMenu = ({
  onApply,
  onReset,
  appliedFrom,
  appliedTo,
  isOpen,
  showReset = true,
  actionsClassName = "",
}) => {
  const [state, setState] = useState(buildEmptyRangeState());
  const [pickerKey, setPickerKey] = useState(0);
  const prevOpenRef = useRef(false);

  const hasUserSelection = hasVisibleDateSelection(state);
  const hasAppliedFilter = Boolean(appliedFrom && appliedTo);
  const shouldShowReset = Boolean(showReset && onReset && (hasAppliedFilter || hasUserSelection));

  const openEmptyPicker = () => {
    setState(buildEmptyRangeState());
    setPickerKey((key) => key + 1);
  };

  const openAppliedPicker = () => {
    setState(buildRangeState(new Date(appliedFrom), new Date(appliedTo)));
  };

  useEffect(() => {
    if (isOpen === undefined) return;

    if (isOpen && !prevOpenRef.current) {
      if (appliedFrom && appliedTo) {
        openAppliedPicker();
      } else {
        openEmptyPicker();
      }
    }
    prevOpenRef.current = Boolean(isOpen);
  }, [isOpen, appliedFrom, appliedTo]);

  const handleApply = () => {
    if (!hasUserSelection) return;

    const start = formatDateForAPI(state[0].startDate);
    const end = formatDateForAPI(state[0].endDate || state[0].startDate);
    onApply(start, end);
  };

  const handleReset = () => {
    openEmptyPicker();
    onReset?.();
  };

  return (
    <>
      <div className="border px-2 rounded-14">
        <DateRange
          key={pickerKey}
          editableDateInputs={true}
          onChange={(item) => setState([item.selection])}
          ranges={state}
          {...dateRangePickerProps}
        />
      </div>
      <div className={`mt-3 d-flex ${shouldShowReset ? "date-range-select__actions" : ""} ${actionsClassName}`.trim()}>
        <button
          type="button"
          className="btn btn-primary w-100 py-3 rounded-14"
          onClick={handleApply}
          disabled={!hasUserSelection}
        >
          Apply
        </button>
        {shouldShowReset && (
          <button type="button" className="btn btn-primary w-100 py-3 rounded-14" onClick={handleReset}>
            Reset
          </button>
        )}
      </div>
    </>
  );
};

export default DateRangeFilterMenu;
